import { IconMenu2, IconLogout } from "@tabler/icons";
import { useTheme } from "styled-components";

import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { useAppDispatch, useAppSelector } from "@sso/hooks/useRedux";
import { logOutUser, selectCurrentUser } from "@sso/store/slices/auth";
import { Flex, Wrapper } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";
import { Typography } from "@sso/ui/Typography";

import { HeaderProfilePicture } from "./HeaderProfilePicture";

interface HeaderProps {
  setDrawerToggle: () => void;
}

export const Header = ({ setDrawerToggle }: HeaderProps) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectCurrentUser);
  const isMatchedUpSm = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`);

  const handleToggleDrawer = () => setDrawerToggle();

  const handleLogOutUser = () => dispatch(logOutUser());

  return (
    <Flex
      as="header"
      bgColor={theme.colors.background.paper}
      zIndex={theme.zIndex.header}
      height={theme.headerHeight}
      position="fixed"
      top="0"
      right="0"
      padding="0.25rem 1rem"
      justify="flex-start"
      width="100%"
    >
      <IconButton color={theme.colors.primary.main} onClick={handleToggleDrawer}>
        <IconMenu2 size={30} stroke={3} />
      </IconButton>

      {isMatchedUpSm && (
        <Typography
          as="h1"
          overflowEllipsis
          width="60%"
          size="1.1rem"
          textAlign="left"
          fontWeight="bold"
          margin="0 0 0 1rem"
          textTransform="capitalize"
        >
          {`${user?.organisation?.name || "NA"} - Basemap SSO`}
        </Typography>
      )}
      <Wrapper flexGrow={1} />
      <HeaderProfilePicture />
      <IconButton title="Log out" color={theme.colors.primary.main} onClick={handleLogOutUser}>
        <IconLogout size={30} />
      </IconButton>
    </Flex>
  );
};
